export const omitProps = (propsToOmit: string[]) => (prop: string) =>
  !propsToOmit.includes(prop);
